import { useState } from 'react';
import { faqs } from '@/mocks/news';

type FaqSectionProps = {
  title?: string;
  intro?: string;
  limit?: number;
};

export default function FaqSection({ title = '常见问题', intro, limit }: FaqSectionProps) {
  const [open, setOpen] = useState<number | null>(0);
  const list = typeof limit === 'number' ? faqs.slice(0, limit) : faqs;

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="font-label text-xs tracking-[0.25em] text-accent-600">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              {intro || '关于内容、更新节奏与使用方式，这里整理了读者问得最多的问题。'}
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 border-y border-background-200">
              {list.map((item, idx) => {
                const isOpen = open === idx;
                return (
                  <div key={item.q}>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : idx)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 py-5 text-left"
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">{item.q}</span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                        }`}
                      >
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                      </span>
                    </button>
                    {isOpen && (
                      <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}